export const cleanHtmlForPreview = (html, maxLength = 100) => {
  const div = document.createElement("div");
  div.innerHTML = html;

  const text = div.textContent || div.innerText || "";
  return `${text.replace(/\s+/g, " ").trim().slice(0, maxLength)}...`;
};

/**
 * Scrolls the window to the top of the page with optional smooth behavior
 * @param {boolean} smooth - Whether to use smooth scrolling (default: true)
 * @param {number} top - The vertical position to scroll to (default: 0)
 */
export const scrollToTop = (smooth = true, top = 0) => {
  window.scrollTo({
    top,
    left: 0,
    behavior: smooth ? "smooth" : "auto",
  });
};
